<template>
  <div :class="{ 'is-loading': pending }" class="base-loading-box">
    <div
      v-if="pending"
      class="base-loading-box__overlay"
      :class="{ 'base-loading-box__page-overlay': theme === 'page' }"
    >
      <base-spinner size="32px" />
      <div v-if="description" class="ml10">{{ description }}</div>
    </div>
    <div class="base-loading-box__data">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseLoadingBox",
  props: {
    pending: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default: "",
    },
    theme: {
      type: String,
      default: "default",
    },
  },
};
</script>

<style lang="less" scoped>
.base-loading-box {
  position: relative;

  &.is-loading {
    overflow: hidden;
  }

  &.is-loading &__data {
    filter: blur(3px);
  }

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: fade(#fff, 70%);
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__page-overlay {
    position: fixed;
    flex-direction: column;
  }
}
</style>
